import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import './styles/tokens.css';
import './styles/main.css';
import { imgUrl } from './utils/img';


Vue.use(ElementUI);
Vue.prototype.$imgUrl = imgUrl;
Vue.config.productionTip = false;

/* 图片加载失败的品牌兜底占位 */
Vue.prototype.$imgError = function (e) {
  const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300"><rect width="100%" height="100%" fill="#f1efe9"/><path d="M160 190 c20 -46 60 -46 80 0" fill="none" stroke="#b8a878" stroke-width="4" stroke-linecap="round"/><path d="M150 190 h100" stroke="#b8a878" stroke-width="3" stroke-linecap="round"/><text x="50%" y="62%" fill="#9ca2ab" font-size="14" letter-spacing="4" text-anchor="middle">暂无图片</text></svg>';
  e.target.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
  e.target.onerror = null;
};

/* 滚动渐显指令：v-reveal */
Vue.directive('reveal', {
  inserted(el) {
    el.classList.add('reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('in');
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    io.observe(el);
    el.__revealIo = io;
  },
  unbind(el) {
    if (el.__revealIo) el.__revealIo.disconnect();
  }
});

new Vue({ router, render: (h) => h(App) }).$mount('#app');
